import type { FC } from "react"

import type { CenterProps, CircularProgressProps } from "@chakra-ui/react"
import { Center, CircularProgress, Text, VStack } from "@chakra-ui/react"

type LoadingAnimationProps = {
  noText?: boolean
  text?: string
  wrapperProps?: CenterProps
} & CircularProgressProps

export const LoadingAnimation: FC<LoadingAnimationProps> = ({
  text,
  color,
  noText,
  wrapperProps,
  ...props
}) => {
  return (
    <Center p={12} w="full" {...wrapperProps}>
      <VStack>
        {!noText && (
          <Text bg="whiteAlpha.700" px={1} py={0} rounded="md">
            {text || "Loading..."}
          </Text>
        )}

        <CircularProgress
          color={color || "main.700"}
          isIndeterminate
          {...props}
        />
      </VStack>
    </Center>
  )
}
